export default __webpack_public_path__ + "static/14-eea58bf4d312415178149e6178cc7d66.jpg";